export const formatters = {
    conditionalLeadingComma: (value, format, lng, options) => {
        return value ? `, ${value}` : "";
    },
};
